import React from 'react';
import { FiPlay, FiArrowRight } from 'react-icons/fi';
import './DemoRequest.css';

const DemoRequest = () => {
  return (
    <section className="demo-request-section">
      <div className="container">
        <div className="demo-request" data-aos="fade-up">
          <div className="demo-video">
            <div className="video-placeholder">
              <div className="play-button">
                <FiPlay size={24} />
              </div>
              <div className="video-overlay"></div>
            </div>
          </div>
          <div className="demo-content">
            <h3 className="demo-title">Want to see StoryCape in action?</h3>
            <p className="demo-description">
              Schedule a personalized demo with our team to see how StoryCape can work for your app.
            </p>
            <a href="#contact" className="btn btn-primary">
              Request a Demo <FiArrowRight className="btn-icon" />
            </a>
            
            <div className="demo-stats">
              <div className="demo-stat">
                {/*<div className="stat-number">500+</div>
                <div className="stat-label">Apps Using StoryCape</div>*/}
              </div>
              <div className="demo-stat">
                <div className="stat-number">99.9%</div>
                <div className="stat-label">Uptime</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="demo-shapes">
        <div className="demo-shape demo-shape-1"></div>
        <div className="demo-shape demo-shape-2"></div>
      </div>
    </section>
  );
};

export default DemoRequest;